import styled from 'styled-components';
import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import { Link, useLocation } from 'react-router-dom';
import Text from '../../atoms/Text';

const Container = styled.nav`
  background-color: ${(props) => props.theme.colors.neutral[100]};
  width: 100%;
  position: fixed;
  bottom: 0;
  max-width: 600px;
  border-top: 1px solid ${(props) => props.theme.colors.neutral[400]};
  width: 100%;
`
const MenuWrapper = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
`
const Menu = styled(Link)`
  color: ${({ $isActive, theme }) => ($isActive ?  theme.colors.primary : theme.colors.text.assistive)};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  min-width: 72px;
`

const Navbar = () => {
  const location = useLocation();

  const menus = [
    {label: '홈', icon: HomeIcon, url: '/'},
    {label: '소통사전', icon: MenuBookIcon, url: '/words'},
    {label: '대화노트', icon: QuestionAnswerRoundedIcon, url: '/conversations'},
    {label: '분석리포트', icon: InsertChartIcon, url: '/report'},
  ]

  return (
    <Container>
      <MenuWrapper>
        {menus.map(({ label, icon: Icon, url }) => {
          const isActive = url === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(url);
          const color = isActive ? 'primary': 'assistive'
          return (
            <li key={label}>
              <Menu to={url} $isActive={isActive}>
                 <Icon sx={{ fontSize: 24 }} />
                <Text color={color}>{label}</Text>
              </Menu>
            </li>  
          );
        })}
      </MenuWrapper>
    </Container>
  )
}

export default Navbar
